import { render, staticRenderFns } from "./HolonView.vue?vue&type=template&id=0c4d2a36&"
import script from "./HolonView.vue?vue&type=script&lang=js&"
export * from "./HolonView.vue?vue&type=script&lang=js&"
import style0 from "./HolonView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports